import { accounts } from '@/store/modules/easy-firestore/accounts';
import { connectionsHistory } from '@/store/modules/easy-firestore/connections-history';
import { dataModels } from '@/store/modules/easy-firestore/data-models';
import { dataTableDetails } from '@/store/modules/easy-firestore/data-table-details';
import { dataTables } from '@/store/modules/easy-firestore/data-tables';
import { freshness } from '@/store/modules/easy-firestore/freshness';
import { apiToStorageConf } from '@/store/modules/easy-firestore/api-to-storage-conf';
import { apiToStorageConfArchive } from '@/store/modules/easy-firestore/api-to-storage-conf-archive';
import { apiToStorageRuns } from '@/store/modules/easy-firestore/api-to-storage-runs';
import { fileUtilitiesRuns } from '@/store/modules/easy-firestore/file-utilities-runs';
import { fileUtilitiesRunsLight } from '@/store/modules/easy-firestore/file-utilities-runs-light';
import { fileUtilitiesConfs } from '@/store/modules/easy-firestore/file-utilities-confs';
import { gbqToGbqTasksStatus } from '@/store/modules/easy-firestore/gbq-to-gbq-tasks-status';
import { getGbqToGbqConfs } from '@/store/modules/easy-firestore/get-gbq-to-gbq-confs';
import { getGbqToGbqConfArchive } from '@/store/modules/easy-firestore/get-gbq-to-gbq-conf-archive';
import { getGbqToGbqRuns } from '@/store/modules/easy-firestore/get-gbq-to-gbq-runs';
import { mirrorExcGcsToGbqConfDetails } from '@/store/modules/easy-firestore/mirror-exc-gcs-to-gbq-conf-details';
import { notes } from '@/store/modules/easy-firestore/notes';
import { schemas } from '@/store/modules/easy-firestore/schemas';
import { storageToStorageConfs } from '@/store/modules/easy-firestore/storage-to-storage-confs';
import { storageToStorageConfsLight } from '@/store/modules/easy-firestore/storage-to-storage-confs-light';
import { storageToStorageConfsArchive } from '@/store/modules/easy-firestore/storage-to-storage-confs-archive';
import { storageToStorageRuns } from '@/store/modules/easy-firestore/storage-to-storage-runs';
import { storageToStorageRunsLight } from '@/store/modules/easy-firestore/storage-to-storage-runs-light';
import { storageToTablesConfs } from '@/store/modules/easy-firestore/storage-to-tables-confs';
import { storageToTablesConfsLight } from '@/store/modules/easy-firestore/storage-to-tables-confs-light';
import { storageToTablesConfArchive } from '@/store/modules/easy-firestore/storage-to-tables-conf-archive';
import { storageToTablesRuns } from '@/store/modules/easy-firestore/storage-to-tables-runs';
import { storageToTablesRunsLight } from '@/store/modules/easy-firestore/storage-to-tables-runs-light';
import { tableToStorageConfs } from '@/store/modules/easy-firestore/table-to-storage-confs';
import { tableToStorageConfsLight } from '@/store/modules/easy-firestore/table-to-storage-confs-light';
import { tableToStorageConfArchive } from '@/store/modules/easy-firestore/table-to-storage-conf-archive';
import { tableToStorageRuns } from '@/store/modules/easy-firestore/table-to-storage-runs';
import { tableToStorageRunsLight } from '@/store/modules/easy-firestore/table-to-storage-runs-light';
import { tablesToTablesRun } from '@/store/modules/easy-firestore/tables-to-tables-run';
import { tailerContextConfs } from '@/store/modules/easy-firestore/tailer-context-conf';
import { tailerContextConfsLight } from '@/store/modules/easy-firestore/tailer-context-conf-light';
import { tailerContextConfsArchive } from '@/store/modules/easy-firestore/tailer-context-conf-archive';
import { tailerExpectations } from '@/store/modules/easy-firestore/tailer-expectations';
import { taskRunDataPreview } from '@/store/modules/easy-firestore/task-run-data-preview';
import { users } from '@/store/modules/easy-firestore/users';
import { vmLauncherConfs } from '@/store/modules/easy-firestore/vm-launcher-confs';
import { vmLauncherConfsLight } from '@/store/modules/easy-firestore/vm-launcher-confs-light';
import { vmLauncherConfArchive } from '@/store/modules/easy-firestore/vm-launcher-conf-archive';
import { vmLauncherRuns } from '@/store/modules/easy-firestore/vm-launcher-runs';
import { vmLauncherRunsLight } from '@/store/modules/easy-firestore/vm-launcher-runs-light';
import { workflowConfs } from '@/store/modules/easy-firestore/workflow-confs';
import { workflowConfsLight } from '@/store/modules/easy-firestore/workflow-confs-light';
import { workflowConfArchive } from '@/store/modules/easy-firestore/workflow-conf-archive';
import { workflowStatus } from '@/store/modules/easy-firestore/workflow-status';
import { workflowStatusLight } from '@/store/modules/easy-firestore/workflow-status-light';
import { xmlConversionConf } from '@/store/modules/easy-firestore/xml-conversion-conf';
import { xmlConversionConfArchive } from '@/store/modules/easy-firestore/xml-conversion-conf-archive';
import { getTableToTableRunsLight } from './get-table-to-table-runs-light';
import { getTableToTableConfsLight } from './get-table-to-table-confs';

export default [
	accounts,
	connectionsHistory,
	schemas,
	notes,
	users,
	mirrorExcGcsToGbqConfDetails,
	apiToStorageConf,
	apiToStorageConfArchive,
	apiToStorageRuns,
	fileUtilitiesRuns,
	fileUtilitiesRunsLight,
	fileUtilitiesConfs,
	gbqToGbqTasksStatus,
	getGbqToGbqConfs,
	getTableToTableConfsLight,
	getGbqToGbqConfArchive,
	getGbqToGbqRuns,
	getTableToTableRunsLight,
	vmLauncherConfs,
	vmLauncherConfsLight,
	vmLauncherConfArchive,
	vmLauncherRuns,
	vmLauncherRunsLight,
	workflowConfs,
	workflowConfsLight,
	workflowConfArchive,
	workflowStatus,
	workflowStatusLight,
	dataModels,
	dataTables,
	freshness,
	dataTableDetails,
	storageToStorageConfs,
	storageToStorageConfsLight,
	storageToStorageConfsArchive,
	storageToStorageRuns,
	storageToStorageRunsLight,
	storageToTablesConfs,
	storageToTablesConfsLight,
	storageToTablesConfArchive,
	storageToTablesRuns,
	storageToTablesRunsLight,
	tablesToTablesRun,
	tableToStorageConfs,
	tableToStorageConfsLight,
	tableToStorageConfArchive,
	tableToStorageRuns,
	tableToStorageRunsLight,
	tailerContextConfs,
	tailerContextConfsLight,
	tailerContextConfsArchive,
	tailerExpectations,
	taskRunDataPreview,
	xmlConversionConf,
	xmlConversionConfArchive,
];
